import { ON_TRACK_TEXT_POINTER, OFF_TRACK_TEXT_POINTER } from '../../constants/assessments';

export const LANGUAGES = {
    ENGLISH: 'EN',
    SPANISH: 'SP',
};

export const DICTIONARY_KEYS = {
    NAME: 'Name',
    TRC: 'TRC',
    ASSESS: 'Assess',
    RESUME: 'Resume',
    FORM: 'Form',
    SKILL: 'Skill',
    ALL_MEASURES: 'All measures',
    SELECT_A_MEASURE: 'Select a measure',
    SCORE: 'Score',
    DATE: 'Date',
    PROGRESS_MONITORING_HISTORY: 'Progress Monitoring History',
    PAUSED: 'Paused',
    RECOMMENDED: 'Recommended',
    TEXT_READING_COMPREHENSION: 'Text Reading Comprehension',
    OPTIONAL: 'Optional',
    INVENTORY: 'Inventory',
    LISTENING_COMPREHENSION: 'Listening Comprehension',
    ORAL_LANGUAGE: 'Oral Language',
    OL: 'OL',
    IDEL_SCREENER: 'IDEL Screener',
    AMPLIFY_ORAL_LANGUAGE_SCREENER: 'Amplify Oral Language Screener',
    YOU_ARE_DONE_PROGRESS_MONITORING_THIS_STUDENT_TODAY:
        'You are done progress monitoring this student today',
    NO_PROGRESS_MONITORING_HISTORY_YET: 'No Progress Monitoring history yet',
    RECOMMENDED_MEASURES: 'Recommended Measures',
    RECOMMENDED_DESCRIPTION: 'RECOMMENDED_DESCRIPTION',
    DISCONTINUED: 'Discontinued',
    TESTED_OUT: 'Tested out',
    ON_TRACK: 'On Track',
    OFF_TACK: 'Off Track',
    ON_TRACK_TEXT: ON_TRACK_TEXT_POINTER,
    OFF_TRACK_TEXT: OFF_TRACK_TEXT_POINTER,
};
